import React from 'react';
import { Link } from 'react-router-dom';
import { Pencil, Trash2 } from 'lucide-react';
import useFeatureFlagManagment from './hooks/useFeatureFlagManagement';
import { Button } from '@/src/shadComponents/ui/button';

interface FeatureFlagActionsProps {
    row: any;
    onDelete: () => void;
}

export default function FeatureFlagActions({
    row,
    onDelete,
}: FeatureFlagActionsProps) {
    const key = row.original.key;
    const id = row.original.id;
    const { deleteFeatureFlag } = useFeatureFlagManagment();

    const performDelete = () => {
        const deleteRequest = async () => {
            await deleteFeatureFlag(key);

            onDelete();
        };

        const shouldDelete = window.confirm(
            `Are you sure you would like to delete ${row.original.key}`,
        );

        if (shouldDelete) {
            deleteRequest();
        }
    };
    return (
        <span className="flex items-center gap-2">
            <Link to={`${id}`}>
                <Button variant="ghost" size="icon">
                    <Pencil className="size-4" />
                </Button>
            </Link>
            <Button variant="ghost" size="icon" onClick={performDelete}>
                <Trash2 className="size-4" />
            </Button>
        </span>
    );
}
